import * as React from "react";
import "../messages/NewTemplate.scss";

//components
import { Button, IconButton, Spinner } from "../Atomics";
import { ChronometerAudioMessage } from "../messages";
import { GroupButtons, ButtonForGroup } from "../Atomics/GroupButtons";
import WavEncoder from "wav-encoder";
import toast from "react-hot-toast";
import { GroupResponse, TemplateMessageResponse } from "../../services/types";
import { getAllGroups } from "../../services/groupService";
import s3 from "../../utils/aws-config";
import CIcon from "@coreui/icons-react";
import { cilMic, cilTrash } from "@coreui/icons";
import { useRef, useState } from "react";
import usePermission from "../../hooks/usePermission";
import { createActivityReq } from "../../services/activityLogService";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import HandleUIError from "../../utils/HandleUIError";
import {
  getMessageStandardTemplateAudio,
  getMessageStandardTemplateText,
  getMessageTemplateAudio,
  getMessageTemplateText,
  sendMessageToAll,
} from "../../services/messagesService";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

type messageTypeOptions = "voice" | "message" | "image";

const ImpromptuMessage: React.FC = () => {
  const { checkPermission } = usePermission();

  const [text, setText] = React.useState("");
  const [file, setFile] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const [groups, setGroups] = React.useState<GroupResponse[]>();
  const [messageType, setMessageType] =
    React.useState<messageTypeOptions>("message");

  const [options, setOptions] = useState<any[]>([]);
  const [selectedOptions, setSelectedOptions] = React.useState<any[]>([]);
  const mediaRecorderRef = useRef<any>(null);
  const audioChunksRef = useRef<any>([]);
  const [recording, setRecording] = useState<string>("");
  const [audioUrl, setAudioUrl] = useState<any>(null);
  const [audioBlob, setAudioBlob] = useState<any>(null);

  const [messageStandardTemplateAudio, setMessageStandardTemplateAudio] =
    React.useState<TemplateMessageResponse[]>([]);
  const [messageStandardTemplateText, setMessageStandardTemplateText] =
    React.useState<TemplateMessageResponse[]>([]);
  const [messageTemplateText, setMessageTemplateText] = React.useState<
    TemplateMessageResponse[]
  >([]);
  const [messageTemplateAudio, setMessageTemplateAudio] = React.useState<
    TemplateMessageResponse[]
  >([]);

  const [selectedTextTemplate, setSelectedTextTemplate] = useState("");
  const [selectedAudioTemplate, setSelectedAudioTemplate] = useState("");

  const fileInputRef = useRef<any>(null);

  // ----------------- TEMPLATE API CALLS -----------------
  React.useEffect(() => {
    async function getMessageTemplate() {
      try {
        const [textTemplate, audioTemplate] = await Promise.all([
          getMessageTemplateText(),
          getMessageTemplateAudio(),
        ]);
        setMessageTemplateText(textTemplate);
        setMessageTemplateAudio(audioTemplate);
      } catch (e) {
        HandleUIError(e);
      }
    }
    getMessageTemplate();
  }, []);

  React.useEffect(() => {
    async function getMessageStandardTemplate() {
      try {
        const [textTemplate, audioTemplate] = await Promise.all([
          getMessageStandardTemplateText(),
          getMessageStandardTemplateAudio(),
        ]);
        setMessageStandardTemplateText(textTemplate);
        setMessageStandardTemplateAudio(audioTemplate);
      } catch (e) {
        HandleUIError(e);
      }
    }
    getMessageStandardTemplate();
  }, []);

  React.useEffect(() => {
    async function getTemplates() {
      try {
        const groupsResponse: any = await getAllGroups();
        setGroups(groupsResponse);

        const mappedOptions = groupsResponse?.map((item: any) => ({
          label: item.name,
          value: item.id,
        }));

        setOptions(mappedOptions);
        setSelectedOptions(mappedOptions); // ✅ default sab selected
      } catch (error) {
        HandleUIError(error);
      }
    }
    getTemplates();
  }, []);

  // ----------------- RECORDING -----------------
  const customStartRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorderRef.current = new MediaRecorder(stream);

    audioChunksRef.current = [];

    mediaRecorderRef.current.ondataavailable = (event: any) => {
      audioChunksRef.current.push(event.data);
    };

    mediaRecorderRef.current.onstop = async () => {
      const audioBlob = new Blob(audioChunksRef.current, { type: "audio/wav" });
      const arrayBuffer = await audioBlob.arrayBuffer();

      const audioContext = new AudioContext();
      const decodedData = await audioContext.decodeAudioData(arrayBuffer);

      const wavBuffer = await WavEncoder.encode({
        sampleRate: decodedData.sampleRate,
        channelData: [decodedData.getChannelData(0)],
      });

      const wavBlob = new Blob([wavBuffer], { type: "audio/wav" });
      setAudioBlob(wavBlob);
      const wavUrl = URL.createObjectURL(wavBlob);
      setAudioUrl(wavUrl);
    };

    mediaRecorderRef.current.start();
    setRecording("recording");
  };

  const customStopRecording = () => {
    mediaRecorderRef.current.stop();
    setRecording("stopped");
  };

  // ----------------- FILE UPLOAD -----------------
  const handleFileUpload = async (file: any, type: string) => {
    return new Promise((resolve, reject) => {
      const params = {
        Bucket: "callguardian",
        Key: file?.name ? file?.name : type,
        Body: file,
        ContentType: file.type,
        ContentDisposition: "inline",
      };

      s3.upload(params, (err: any, data: any) => {
        if (err) {
          console.error("Error uploading file:", err);
          reject(err);
        } else {
          resolve(data.Location);
        }
      });
    });
  };

  // ----------------- HANDLE SEND -----------------
  async function triggerEndpointService(msg: any) {
    setLoading(true);

    try {
      if (selectedOptions?.length > 0) {
        let msg2: any = null;

        if (messageType === "message") {
          msg2 = msg;
        } else if (messageType === "image") {
          msg2 = await handleFileUpload(msg, "");
        } else if (messageType === "voice") {
          if (audioBlob) {
            const randomNumber: number = Math.floor(Math.random() * 100) + 1;
            const timestamp: number = Date.now();
            msg2 = await handleFileUpload(
              audioBlob,
              `recorded-${randomNumber}-${timestamp}-media.wav`
            );
          } else if (audioUrl) {
            msg2 = audioUrl;
          }
        }

        if (!msg2) {
          toast.error("Please enter a message before sending");
          return;
        }

        const data: any = {
          message: msg2,
          type: messageType,
          group_ids: selectedOptions?.map((item: any) => item.value), // ✅ value = id
        };

        const res: any = await sendMessageToAll(data);

        if (res.data.data.status === "success") {
          await createActivityReq("Impromptu Message Send Successfully");

          // ✅ Reset
          setText("");
          setFile(null);
          setAudioUrl(null);
          setAudioBlob(null);
          setRecording("");
          setSelectedOptions([...options]); // reset: sab select
          setSelectedTextTemplate("");
          setSelectedAudioTemplate("");

          toast.success("Message sent successfully");

          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        }
      } else {
        toast.error("Please Select Group Users to send Impromptu Message.");
      }
    } catch (e) {
      HandleUIError(e);
    } finally {
      setLoading(false);
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;
    setSelectedTextTemplate(selectedId);

    const combinedTemplates = [
      ...messageStandardTemplateText,
      ...messageTemplateText,
    ];

    const selectedTemplate = combinedTemplates.find(
      (t) => String(t.id) === selectedId
    );

    setText(selectedTemplate?.text ?? "");
  };

  const handleAudioChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;
    setSelectedAudioTemplate(selectedId);

    const selectedTemplate =
      messageStandardTemplateAudio.find((t) => String(t.id) === selectedId) ||
      messageTemplateAudio.find((t) => String(t.id) === selectedId);

    if (selectedTemplate) {
      setAudioUrl(selectedTemplate.filePath);
      setAudioBlob(null);
    }
  };

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      Note: You can select multiple groups at a time to send Impromptu Message
      to Mass Audience
    </Tooltip>
  );

  React.useEffect(() => {
    const css = `
      /* general fallbacks for many possible classnames/attributes */
      .rmsc .dropdown-content .item,
      .rmsc .options .option,
      .rmsc .option,
      .rmsc .item,
      .rmsc li.option {
        background: none !important;
        background-color: #20202A !important;
        color: white !important;
        box-shadow: none !important;
      }

    
}

      /* hover single item */
      .rmsc .option:hover,
      .rmsc .dropdown-content .item:hover,
      .rmsc .item:hover {
        background-color: #374151 !important;
        color: black !important;
      }

      

      /* selected single item (many selector variants) */
      .rmsc .option.selected,
      .rmsc .dropdown-content .item.selected,
      .rmsc .item.selected,
      .rmsc [aria-selected="true"],
      .rmsc [data-selected="true"] {
        background-color: #0c0c0cff !important;
        color: white !important;
      }

      /* selected + hover */
      .rmsc .option.selected:hover,
      .rmsc .dropdown-content .item.selected:hover {
        background-color: #000000ff !important;
        color: white !important;
      }

      /* override inline style attributes if present */
      .rmsc .option[style],
      .rmsc .dropdown-content .item[style],
      .rmsc .item[style] {
        background: none !important;
      }

      /* chips inside input */
      .rmsc .chip {
        background-color: #374151 !important;
        color: white !important;
      }

      
    `;
    const s = document.createElement("style");
    s.setAttribute("data-rmsc-overrides", "true");
    s.innerHTML = css;
    document.head.appendChild(s);
    return () => s.remove();
  }, []);

  // ----------------- RENDER -----------------
  return (
    <div className="new-staff-container w-100 mt-2">
      <div className="card-header d-flex justify-content-between align-items-center">
        <p className="text-light fs-5">Impromptu Message</p>
      </div>

      <div className="px-3 pt-2 d-flex justify-content-between" style={{ gap: 15 }}>
        <div className="mb-3 impromtu-msg mt-3">
          <OverlayTrigger placement="right" overlay={renderTooltip}>
            <div>
              <MultiSelect
                options={options}
                value={selectedOptions}
                onChange={setSelectedOptions}
                labelledBy="Select Groups"
                className="rmsc"
              />
            </div>
          </OverlayTrigger>
        </div>

        <div className="d-flex justify-content-center flex-column mt-3 mb-2">
          <GroupButtons>
            <ButtonForGroup
              label="Text"
              checked={messageType === "message"}
              onClick={() => setMessageType("message")}
            />
            <ButtonForGroup
              label="Audio"
              checked={messageType === "voice"}
              onClick={() => setMessageType("voice")}
            />
            <ButtonForGroup
              label="Image"
              checked={messageType === "image"}
              onClick={() => setMessageType("image")}
            />
          </GroupButtons>

          {/* ------------------ MESSAGE ------------------ */}
          {messageType === "message" && (
            <div className="m-0 me-2 w-100 mt-3">
              <select
                value={selectedTextTemplate}
                onChange={handleChange}
                className="form-select template-select w-100"
              >
                <optgroup className="py-3" label="Standard">
                  <option className="text-start" value="">
                    Select Message Template
                  </option>
                  {messageStandardTemplateText?.map((template) =>
                    template.status && template?.type === "text" ? (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    ) : null
                  )}
                </optgroup>
                <optgroup className="py-3" label="Custom">
                  {messageTemplateText?.map((template) =>
                    !template.status && template?.type === "text" ? (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    ) : null
                  )}
                </optgroup>
              </select>
            </div>
          )}

          {/* ------------------ AUDIO ------------------ */}
          {messageType === "voice" && (
            <div className="m-0 me-2 w-100 mt-3">
              <select
                value={selectedAudioTemplate}
                onChange={handleAudioChange}
                className="form-select template-select w-100"
              >
                <optgroup className="py-3" label="Standard">
                  <option className="text-start" value="">
                    Select Audio Template
                  </option>
                  {messageStandardTemplateAudio?.map((template) =>
                    template.status && template?.type === "audio" ? (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    ) : null
                  )}
                </optgroup>
                <optgroup className="py-3" label="Custom">
                  {messageTemplateAudio?.map((template) =>
                    !template.status && template?.type === "audio" ? (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    ) : null
                  )}
                </optgroup>
              </select>
            </div>
          )}
        </div>
      </div>

      {/* ------------------ RENDER TEXT ------------------ */}
      {messageType === "message" && (
        <div className="search-phone d-flex flex-column">
          <div className="px-3 mb-4">
            <textarea
              rows={5}
              className="form-control shadow-none"
              style={{
                backgroundColor: "#24242C",
                border: "2px solid #44454a",
                color: "#51fffe",
              }}
              value={text}
              maxLength={300}
              onChange={(e) => setText(e.target.value)}
            />
            <div className="p-1 rounded-2 px-2" style={{ border: "2px solid #44454a" }}>
              <p className="py-1 text-end">{`${text?.length}/300`}</p>
            </div>
          </div>
          {checkPermission("Send Group Message") && (
            <div className="align-self-end px-3 pb-3">
              <Button
                onClick={() => triggerEndpointService(text)}
                disabled={loading}
                className="px-4"
              >
                {loading ? <Spinner /> : "Send"}
              </Button>
            </div>
          )}
        </div>
      )}

      {/* ------------------ RENDER AUDIO ------------------ */}
      {messageType === "voice" && (
        <div className="text-center d-flex flex-column align-content-center" style={{ minHeight: 250 }}>
          <p>{recording}</p>
          {recording === "" && (
            <Button className="mt-2 mb-3 w-50 mx-auto" onClick={customStartRecording}>
              START RECORDING <CIcon className="ms-1" size="xl" icon={cilMic} />
            </Button>
          )}
          <div className="d-flex">
            {recording === "recording" && (
              <>
                <div className="d-flex align-items-center ms-4">
                  <div className="recording-status p-0 m-0 me-1" />
                  <ChronometerAudioMessage className="audio-time-text m-0 p-0" />
                </div>
                <Button
                  className="stop-button-container m-0 p-0 me-2"
                  onClick={customStopRecording}
                >
                  <div className="icon-stop-button" />
                </Button>
              </>
            )}
          </div>
          <div className="d-flex align-items-center">
            {audioUrl && (
              <AudioPlayer src={audioUrl} showJumpControls={false} className="audio-player-container mb-3" style={{ background: "#0B0B17", color: "white" }} />
            )}
            {audioUrl && (
              <IconButton
                icon={cilTrash}
                size="xxl"
                onClick={() => {
                  setAudioUrl(null);
                  setRecording("");
                }}
              />
            )}
          </div>
          {checkPermission("Send Group Message") && (
            <div className="d-flex justify-content-end px-3 pb-3">
              <Button
                onClick={() => triggerEndpointService(audioBlob)}
                disabled={loading}
                className="px-4"
              >
                {loading ? <Spinner /> : "Send"}
              </Button>
            </div>
          )}
        </div>
      )}

      {/* ------------------ RENDER IMAGE ------------------ */}
      {messageType === "image" && (
        <div className="search-phone d-flex flex-column">
          <div className="text-center" style={{ minHeight: 250 }}>
            <input
              type="file"
              className="form-control w-50 mx-auto mt-4"
              onChange={(e) => {
                if (e.target.files && e.target.files.length > 0) {
                  setFile(e.target.files[0]);
                }
              }}
              accept="image/*"
              ref={fileInputRef}
            />
          </div>
          {checkPermission("Send Group Message") && (
            <div className="align-self-end px-3 pb-3">
              <Button
                onClick={() => triggerEndpointService(file)}
                disabled={loading}
                className="px-4"
              >
                {loading ? <Spinner /> : "Send"}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ImpromptuMessage;
